const IError = {
    status:Number,
    Message:String,
}
export const getError = (Error) =>{ 
    if (Error.message && !Error.response) {
        IError.status = 500;
        IError.Message = "Ocurrio un problema con el servicio intentar mas tarde.";
        return IError;
    } 
    IError.status = 400;
    IError.Message = Error?.response?.data?.Message ?? "Ocurrio un problema con el servicio intentar mas tarde.";
    return IError
}